<mat-card class="lib-fieldset mat-elevation-z{{matElevation}}">
  <mat-card-title class="lib-fieldset-title">{{textTitle}}</mat-card-title>

  <div class="lib-fieldset-container">
    <ng-content></ng-content>
  </div>
</mat-card>
